var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center md-layout md-alignment-center-center"},[(_vm.hasPermission && !_vm.value)?_c('md-checkbox',{on:{"change":_vm.updateValue},model:{value:(_vm.updatedValue),callback:function ($$v) {_vm.updatedValue=$$v},expression:"updatedValue"}}):_c('md-icon',{class:_vm.value ? 'text-success' : 'text-danger'},[_vm._v("\n    "+_vm._s(_vm.value ? "check_circle" : "cancel")+"\n    "),_c('md-tooltip',[_vm._v("Aprobado "+_vm._s(_vm._f("fromNowDate")(_vm.validationDate)))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Supplies/Validation/SupplyValidator.vue